import { Messages } from "./messages";
import { Ticket } from "./ticket";

export class ActionResult {
  constructor(public ticket: Ticket, public messages: Messages) {}

  public static get EMPTY(): ActionResult {
    return new ActionResult(Ticket.EMPTY, Messages.EMPTY);
  }
}
